import { deleteSavedCalendarView } from '../actions/publicActions';
import { getStore } from '../store/store';
import { mutator } from 'satcheljs';
import { deleteSavedCalendarViewService } from '../services/deleteSavedCalendarViewService';
import { logSaveViewsApiFailure } from '../utils/logServiceResponseUtil';

mutator(deleteSavedCalendarView, actionMessage => {
    let response = deleteSavedCalendarViewService(actionMessage.id);
    if (response != null) {
        getStore().savedViewMap.delete(actionMessage.id);

        if (getStore().currentlyDisplayedViewId == actionMessage.id) {
            getStore().currentlyDisplayedViewId = null;
        }
    } else {
        logSaveViewsApiFailure('delete');
    }
});
